import SDError from './SDError';

export default class TimeoutError extends SDError {
  type = 'error';
}



// WEBPACK FOOTER //
// ./src/model/TimeoutError.js